var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M22.003 6.5c1.937 0 3.308.798 4.11 1.94l.154.232c.724 1.181.924 2.734.547 4.323l-.084.317c-.174.606-.63 1.413-1.279 2.334l-.29.402a42 42 0 0 1-2.078 2.57l-.78.883a114 114 0 0 1-4.488 4.683L16.77 25.21c-.375.362-1.048.384-1.46.067l-.079-.067c-.992-.962-2.87-2.813-4.736-4.834l-.797-.875a51 51 0 0 1-2.55-3.042l-.308-.411c-.7-.953-1.224-1.802-1.477-2.463l-.091-.273c-.456-1.592-.33-3.17.324-4.4l.137-.24C6.507 7.408 7.93 6.5 9.996 6.5c1.928 0 3.376.984 4.356 1.99l.19.201c.247.27.464.54.65.795L16 10.59l.807-1.104q.21-.287.47-.593l.18-.202c.98-1.071 2.49-2.191 4.546-2.191Z"
  })));
};
export default SvgHeart;